import React from 'react'
import { Category } from 'lib/types'
import { ProductListLayout } from '../../components/ProductListLayout'

interface Props {
  category: Category
}

export const CategoryScene = ({ category }: Props) => {
  const { id, name, description } = category

  return (
    <ProductListLayout
      title={name}
      categoryId={id}
      description={description}
    />
  )
}
